import type { FaireProductEntity } from "../../entity_types/product";

export const p_dqx1p4eue4: FaireProductEntity = {
  token: "p_dqx1p4eue4",
  type: "product",
  name: "Hot Dog High Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/d5b5340bd3a2e3a9f7337b6541fc3ff7a2cc87938641737f44c6a5fa2e16cc59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0036ad35a82af018c85ddfbfcbd37eeb59adf2ec0f28fe68dae77098b27b61b.png",
    "https://cdn.faire.com/fastly/765e4805b20bb3ca608bb0f5e7904ea05eb3ab03c70d76b5a2e4fd01281cd23b.png",
    "https://cdn.faire.com/fastly/08fc1d62962290996502ff5609da234cb23c7a4344cbf5676b6ce87d705f8115.png",
    "https://cdn.faire.com/fastly/83ee41f3b2d445956549af41a75a0f598d6acdf5021c204ba544ba177cebfd97.png",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:49.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
